(function(){
  function boot(root){
    if (root.dataset.cuBooted) return;
    root.dataset.cuBooted = '1';
    var node = root.querySelector('[data-cu-json]');
    if (!node) return;
    var D = JSON.parse(node.textContent);
    var VS = D.variants || [];

    var rail    = root.querySelector('[data-cu-rail]');
    var thumbs  = root.querySelector('[data-cu-thumbs]');
    var liveImg = root.querySelector('[data-cu-liveimg]');
    var ovchip  = root.querySelector('[data-cu-ovchip]');
    var frame   = root.querySelector('[data-cu-frame]');
    var tell    = root.querySelector('[data-cu-tell]');
    var idIn    = root.querySelector('[data-cu-id]');
    var priceEl = root.querySelector('[data-cu-price]');
    var cmpEl   = root.querySelector('[data-cu-compare]');
    var atc     = root.querySelector('[data-cu-atc]');
    var atcTxt  = root.querySelector('[data-cu-atctext]');
    var sprice  = root.querySelector('[data-cu-sprice]');
    var svar    = root.querySelector('[data-cu-svar]');
    var sticky  = root.querySelector('[data-cu-sticky]');
    var form    = root.querySelector('.cu-form');
    var groups  = [].slice.call(root.querySelectorAll('[data-cu-opt]'));


    /* The product renders carry a transparent margin that differs per file, so
       measure the real card bounds off the alpha channel instead of guessing. */
    var fitCache = {};
    var CARD_RATIO = 1.588;
    var OVERSCAN = 1.012;  /* hides sub-pixel measurement error; the frame clips it */
    function applyFit(f){
      if (!frame || !liveImg) return;
      /* A full or window render is a whole card. A half render is only the top
         strip, so map it onto the top of the card instead of stretching it. */
      var strip = Math.min(100, CARD_RATIO / f.ratio * 100);
      var tw = 100 * OVERSCAN, th = strip * OVERSCAN;
      var tl = -(tw - 100) / 2, tt = -(th - strip) / 2;
      liveImg.style.width  = (tw / f.w) + '%';
      liveImg.style.left   = (tl - f.x * tw / f.w) + '%';
      liveImg.style.height = (th / f.h) + '%';
      liveImg.style.top    = (tt - f.y * th / f.h) + '%';
    }
    function fitCard(url){
      if (!url || !frame) return;
      if (fitCache[url]){ applyFit(fitCache[url]); return; }
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function(){
        try {
          var W = 400, H = Math.max(1, Math.round(W * im.naturalHeight / im.naturalWidth));
          var cv = document.createElement('canvas');
          cv.width = W; cv.height = H;
          var cx = cv.getContext('2d', { willReadFrequently: true });
          cx.drawImage(im, 0, 0, W, H);
          var d = cx.getImageData(0, 0, W, H).data;
          var x0 = W, y0 = H, x1 = -1, y1 = -1;
          for (var y = 0; y < H; y++){
            for (var x = 0; x < W; x++){
              if (d[(y * W + x) * 4 + 3] > 18){
                if (x < x0) x0 = x;
                if (x > x1) x1 = x;
                if (y < y0) y0 = y;
                if (y > y1) y1 = y;
              }
            }
          }
          if (x1 < 0) return;
          var fw = (x1 - x0 + 1) / W, fh = (y1 - y0 + 1) / H;
          var f = { x: x0 / W, y: y0 / H, w: fw, h: fh,
                    ratio: (fw * im.naturalWidth) / (fh * im.naturalHeight) };
          fitCache[url] = f;
          applyFit(f);
        } catch (e) {}
      };
      im.src = url;
    }

    function chosen(){
      return groups.map(function(g){
        var t = g.querySelector('.cu-tile[aria-checked="true"]');
        return t ? t.getAttribute('data-cu-val') : null;
      });
    }
    function findWith(sel, needAvail){
      for (var i = 0; i < VS.length; i++){
        var ok = true;
        for (var j = 0; j < sel.length; j++){
          if (sel[j] !== null && VS[i].opts[j] !== sel[j]){ ok = false; break; }
        }
        if (ok && (!needAvail || VS[i].avail)) return VS[i];
      }
      return null;
    }
    function paintAvailability(){
      var base = chosen();
      groups.forEach(function(g, gi){
        [].slice.call(g.querySelectorAll('.cu-tile')).forEach(function(t){
          var sel = base.slice();
          sel[gi] = t.getAttribute('data-cu-val');
          var want = findWith(sel, true) ? '0' : '1';
          if (t.getAttribute('data-oos') !== want) t.setAttribute('data-oos', want);
        });
      });
    }
    function setTells(){
      if (!tell) return;
      var parts = groups.map(function(g){
        var t = g.querySelector('.cu-tile[aria-checked="true"]');
        return t ? t.querySelector('.cu-tname').textContent.trim() : '';
      }).filter(Boolean);
      var html = parts.map(function(x){
        return '<span>' + x.replace(/&/g,'&amp;').replace(/</g,'&lt;') + '</span>';
      }).join('');
      if (tell.innerHTML !== html) tell.innerHTML = html;
    }
    var busy = false;
    function apply(){
      if (busy) return;
      busy = true;
      try { run(); } finally { busy = false; }
    }
    function run(){
      groups.forEach(function(g){
        var t = g.querySelector('.cu-tile[aria-checked="true"]');
        var lab = g.querySelector('[data-cu-optval]');
        if (lab && t) lab.textContent = t.getAttribute('data-cu-val');
      });
      paintAvailability();
      setTells();
      var v = findWith(chosen(), false);
      if (!v){
        if (atc){ atc.disabled = true; }
        if (atcTxt) atcTxt.textContent = D.unavailable;
        return;
      }
      if (idIn) idIn.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (sprice) sprice.textContent = v.price;
      if (svar) svar.textContent = v.title;
      if (cmpEl){
        if (v.hasCompare){ cmpEl.textContent = v.compare; cmpEl.hidden = false; }
        else { cmpEl.hidden = true; }
      }
      if (ovchip && D.chip){
        var chipG = null;
        groups.forEach(function(g){ if (g.getAttribute('data-kind') === 'chip') chipG = g; });
        var pick = chipG && chipG.querySelector('.cu-tile[aria-checked="true"]');
        var pv = pick ? pick.getAttribute('data-cu-val').toLowerCase() : '';
        var spec = null;
        if (pv.indexOf('no chip') > -1 || pv.indexOf('none') > -1) spec = null;
        else if (pv.indexOf('small') > -1) spec = D.chip.sm;
        else if (pv) spec = D.chip.lg;
        if (spec){
          ovchip.hidden = false;
          ovchip.style.width = spec.w + '%';
          ovchip.style.height = spec.h + '%';
          ovchip.style.left = spec.x + '%';
          ovchip.style.top = spec.y + '%';
          if (spec.img) ovchip.style.backgroundImage = 'url(' + spec.img + ')';
        } else {
          ovchip.hidden = true;
        }
      }
      var peel = root.querySelector('.cu-peelsvg');
      if (peel){
        var covG = null;
        groups.forEach(function(g){ if (g.getAttribute('data-kind') === 'cover') covG = g; });
        var cpick = covG && covG.querySelector('.cu-tile[aria-checked="true"]');
        var cv = cpick ? cpick.getAttribute('data-cu-val').toLowerCase() : '';
        peel.style.display = cv.indexOf('half') > -1 ? 'none' : '';
      }
      if (atc) atc.disabled = !v.avail;
      if (atcTxt) atcTxt.textContent = v.avail ? D.add : D.soldout;
      if (v.img && liveImg && liveImg.getAttribute('src') !== v.img){
        liveImg.setAttribute('src', v.img);
        if (liveImg.hasAttribute('srcset')) liveImg.removeAttribute('srcset');
        if (liveThumb) liveThumb.src = v.img;
        fitCard(v.img);
      }
    }

    groups.forEach(function(g){
      g.addEventListener('click', function(e){
        var t = e.target.closest ? e.target.closest('.cu-tile') : null;
        if (!t || !g.contains(t)) return;
        [].slice.call(g.querySelectorAll('.cu-tile')).forEach(function(x){
          x.setAttribute('aria-checked', x === t ? 'true' : 'false');
        });
        apply();
        revealLive();
      });
    });

    /* When an option changes, bring the live preview back into view so the
       change is actually seen. Mobile: snap the rail back to slide 1.
       Desktop (grid, no horizontal scroll): only scroll the page if the
       preview has left the viewport. Then pulse it either way. */
    function revealLive(){
      var live = root.querySelector('.cu-slide--live');
      if (!live) return;
      var scrollable = rail && rail.scrollWidth > rail.clientWidth + 4;
      if (scrollable && rail.scrollLeft > 2){
        rail.scrollTo({ left: 0, behavior: 'smooth' });
      } else if (!scrollable){
        var r = live.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        if (r.bottom < 80 || r.top > vh - 120){
          live.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
      var card = root.querySelector('[data-cu-frame]');
      if (!card) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      card.classList.remove('cu-pulse');
      void card.offsetWidth;
      card.classList.add('cu-pulse');
    }

    var liveThumb = null;
    if (rail && thumbs){
      var slides = [].slice.call(rail.children);
      slides.forEach(function(s, i){
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cu-thumb';
        b.setAttribute('aria-label', 'View slide ' + (i + 1));
        b.setAttribute('aria-current', i === 0 ? 'true' : 'false');
        var im = s.querySelector('img');
        if (im){
          var c = document.createElement('img');
          c.src = im.getAttribute('src');
          c.alt = '';
          c.loading = 'lazy';
          b.appendChild(c);
          if (i === 0) liveThumb = c;
        } else {
          var label = s.querySelector('.cu-kicker') || s.querySelector('h3');
          var sp = document.createElement('span');
          sp.textContent = label ? label.textContent : 'More';
          b.appendChild(sp);
        }
        b.addEventListener('click', function(){
          rail.scrollTo({ left: slides[i].offsetLeft - rail.offsetLeft, behavior: 'smooth' });
        });
        thumbs.appendChild(b);
      });
      var tb = [].slice.call(thumbs.children);
      var tick;
      rail.addEventListener('scroll', function(){
        clearTimeout(tick);
        tick = setTimeout(function(){
          var i = Math.round(rail.scrollLeft / (rail.clientWidth + 10));
          if (i < 0) i = 0;
          if (i > tb.length - 1) i = tb.length - 1;
          tb.forEach(function(b, k){
            var want = k === i ? 'true' : 'false';
            if (b.getAttribute('aria-current') !== want) b.setAttribute('aria-current', want);
          });
        }, 70);
      }, { passive: true });
    }

    var qi = root.querySelector('.cu-qty input');
    var mn = root.querySelector('[data-cu-minus]');
    var pl = root.querySelector('[data-cu-plus]');
    if (mn && qi) mn.addEventListener('click', function(){ qi.value = Math.max(1, (parseInt(qi.value, 10) || 1) - 1); });
    if (pl && qi) pl.addEventListener('click', function(){ qi.value = (parseInt(qi.value, 10) || 1) + 1; });

    var sadd = root.querySelector('[data-cu-sadd]');
    if (sadd && form){
      sadd.addEventListener('click', function(){
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      });
    }
    var mobileQ = window.matchMedia('(max-width: 749px)');
    if (sticky && atc && 'IntersectionObserver' in window && mobileQ.matches){
      var stuck = false;
      new IntersectionObserver(function(en){
        var e = en[0];
        var want = !e.isIntersecting && e.boundingClientRect.top < 0;
        if (want === stuck) return;
        stuck = want;
        sticky.classList.toggle('on', want);
      }, { threshold: 0 }).observe(atc);
    }

    var fomoN = root.querySelector('.cu-fomo-n[data-cu-count]');
    if (fomoN && 'IntersectionObserver' in window){
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var fio = new IntersectionObserver(function(en){
        if (!en[0].isIntersecting) return;
        fio.disconnect();
        var end = parseInt(fomoN.getAttribute('data-cu-count'), 10) || 0;
        if (reduceMotion || end < 2){ fomoN.textContent = end; return; }
        var t0 = performance.now();
        (function step(t){
          var p = Math.min(1, (t - t0) / 900);
          fomoN.textContent = Math.round(end * (1 - Math.pow(1 - p, 3)));
          if (p < 1) requestAnimationFrame(step);
        })(t0);
      }, { threshold: .6 });
      fio.observe(fomoN);
    }

    apply();
    if (liveImg) fitCard(liveImg.getAttribute('src'));
  }

  function scan(){
    [].slice.call(document.querySelectorAll('.cu-pdp-root')).forEach(boot);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
